module.exports = ".img-center-icon {\r\n    text-align: center;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/buyer-upload-section/modules/upload-list/upload-list.component.css
// module id = ./src/app/modules/dashboard/buyer-upload-section/modules/upload-list/upload-list.component.css
// module chunks = dashboard.module